import React, { useEffect, useState, useRef } from "react";
import { Box, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CourseCard from "../../../component/molecule/Cards/CourseCard";
import HeadingComponent from "../../../component/atom/Headings/Heading";
import { Actions } from "../../../core/modules/Actions";
import { connect } from "react-redux";
import _ from "lodash";
import {
  DEFAULT_CURRENCY,
  IMAGE_URL,
  onGetCurrencySymble,
  PLAN_STATUS,
} from "../../../core/Constant";
import { HeaderStudent } from "../../../component/organism/Header";
import { getText } from "../../../core/Constant";

const CourseScreen = ({ coursecatalog, getCousreCatalog, verifyToken, getInitialCourseDetails, getSystemCurrency, systemCurrency, show }) => {
  const navigate = useNavigate();
  const [newcoursecatalog, setNewCourseCatalog] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("")
  
  let currencyId = localStorage.getItem('GlobalCurrency');

  const [isShow, setIsShow] = useState(0);

   useEffect(()=>{
     if(currency && currencyList?.length > 0){
       const selectedCurrency = currencyList?.find((c)=> c?.id?.toString() === currency?.toString() )
       setSelectedCurrency(selectedCurrency)
       const currencyCode = selectedCurrency?.currency
       getCousreCatalog(currencyCode);
     }
    },[currency,currencyList])

  useEffect(() => {
    setIsShow(show == 1);
  }, [show]);


  const navigateToCourseDetails = (
    courseId,
    isRegistered,
    course,
    selectedPlan,
  ) => {
    if (!isRegistered) {
      getInitialCourseDetails(selectedCurrency?.currency);
    }
    navigate("/course-details", {
      state: {
        course_id: courseId,
        is_registered: isRegistered,
        course,
        selectedPlan,
      },
    });
  };

  useEffect(() => {
    getCousreCatalog(DEFAULT_CURRENCY);
    verifyToken();
  }, []);

  useEffect(() => {
    setCurrency(currencyId)
    getSystemCurrency()
  }, [])

  useEffect(() => {
      const currency = localStorage.getItem("GlobalCurrency")
      if(currency){
        const list = _.map(systemCurrency, (item, index) => {
        return {
          id: item?.id,
          currency: item?.currency,
          currency_name: item?.currency_name,
        };
      });
      const selectedCurrency = list?.find((curnncy)=> curnncy?.id?.toString() === currency?.toString() )
      setCurrencyList(list);
      setCurrency(selectedCurrency?.id);
      } else {
       const list = _.map(systemCurrency, (item, index) => {
        return {
          id: item?.id,
          currency: item?.currency,
          currency_name: item?.currency_name,
        };
      });
      setCurrencyList(list);
      setCurrency(list[0]?.id);
     }
    }, [systemCurrency]);

  const onCurrancyChange = (e) => {
    const Selectedvalue = getText(e);
    setCurrency(Selectedvalue);
    localStorage.setItem("GlobalCurrency", Selectedvalue)
  };

  useEffect(() => {
    console.log("oioioioo ", _.get(coursecatalog,'[0]','no') )
    setNewCourseCatalog(coursecatalog);
  }, [coursecatalog]);

  const getCurrency = (item) => {
      const selectedCurrency = item?.prices?.find(newcurrency => newcurrency?.currency_id === currency);
      if (selectedCurrency) {
        const currencySymbol = onGetCurrencySymble(_.get(selectedCurrency, "currency.currency"));
        const price = _.get(selectedCurrency, "price", "");
        localStorage.setItem('GlobalCurrency', selectedCurrency?.currency_id)
        return `${currencySymbol}${price}`;
      } else {
        return "";
      }
    };
  return (
    <>

      <Box className="main-screen-container">
        <Box mt={2}>
          <HeadingComponent
            text={"Course Catalog"}
            fontweigth={600}
            size={'26px'}
            fontfamily={"Montserrat"}
          />
        </Box>
        {isShow ? <HeaderStudent dashboard={true} onCurrancyChange={onCurrancyChange} currancy={currency} newcurrancyList={currencyList} />
          : <></>}
        <Box sx={{ mt: 2 }}>
          <Grid
            rowGap={2}
            container
            columnSpacing={{ sm: 8, md: 2, lg: 4, xl: 2 }}
          >
            {_.map(newcoursecatalog,(item, index) => {
              const indexValue = _.findIndex(_.get(item, 'prices', []), i => {
                return i.currency_id == currency
              });

              let price = _.get(item, 'prices[0].price', 0.00);
              let currencyType = _.get(item, 'prices[0].currency.currency', 'CAD')
              if (indexValue > -1) {
                const dataList = _.get(item, 'prices', []);
                price = dataList[indexValue]?.price || 0.00
                currencyType = dataList[indexValue]?.currency?.currency || 'CAD'
              }
              return (
                <>
                  <Grid item key={item?.id + `${index}`}>
                    <CourseCard
                      course={item}
                      plans={item?.prices}
                      isMultiBatch={item?.is_multi_batch}
                      image={IMAGE_URL + item?.course_image}
                      selectValue={2}
                      price={ item?.is_multi_batch === 0 ? getCurrency(item) : ""}
                      reviewCount={item?.totalRatingCount}
                      reviewAvg={item?.averageRating}
                      currancy={onGetCurrencySymble(currencyType)}
                      weeks={item?.duration !== null ? item?.duration : item?.prices?.[0]?.duration_weeks }
                      onCourseDetails={(selectedPlan) => {
                        navigateToCourseDetails(
                          item?.id,
                          item?.is_registered,
                          item,
                          selectedPlan,
                        );
                      }}
                      onViewMore={(selectedPlan)=>{
                       navigateToCourseDetails(
                          item?.id,
                          item?.is_registered,
                          item,
                          selectedPlan,
                        );
                      }}
                      title={item?.name}
                      freeDescription={item?.course_info || item?.name}
                      btnText={"View"}
                      description={item?.description}
                      isRegisterd={item?.is_registered}
                      isFree={_.get(item, "is_free", 0)}
                      courseStatus={item?.is_expired ? PLAN_STATUS.EXPIRED : ""}
                      selectedCurrency={selectedCurrency}
                    />
                  </Grid>
                </>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default connect(
  (state) => ({
    coursecatalog: state.course.get("coursecatalog"),
    systemCurrency: state.auth.get("systemCurrency"),
    show: state.common.get('show')
  }),
  {
    getCousreCatalog: Actions.course.getCousreCatalog,
    verifyToken: Actions.auth.verifyToken,
    getInitialCourseDetails: Actions.guest.getInitialCourseDetails,
    getSystemCurrency: Actions.auth.getSystemCurrency
  }
)(CourseScreen);
